goog.provide('el8.appchart.dialog.rxRefillRequestDetail');

goog.require('el8.uiwidget.NewDialog');
goog.require('el8.template.render.rxRefillRequest');

el8.appchart.dialog.rxRefillRequestDetail = (function() {

    var that = new el8.uiwidget.NewDialog({
        title: 'Full Detail of Rx Refill Request',
        autoHeight: true,
        width: 610,
        position: 'center',
        showXButton: true
    });
    
    var super_show = that.show;
    that.show = function(item) {
        super_show.call(that);
        $.el8_ajax({
            url: '/patient/' + el8.ptdata.currPatient.getId() + '/rxrefill/'+ item.getId() +'/details/',
            type: "GET",
            data: null,
            success: function(data) {
                var tmplArgs = {detail: data};
                that.setContent(el8.template.render.rxRefillRequest.fullDetail(tmplArgs));
                that.adjustPosition();
            }
        });
    };
    
    return that;

})();